import React from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment-timezone';
import { useTheme } from '@material-ui/core/styles';

import { useVehicleLoader } from '../../hooks/vehicleLoader';
import { fullSearchFilterDateFormat } from '../../utils/variables';
import WarningIcon from '@material-ui/icons/Warning';

const VehicleCarPoolingCard = props => {
  const theme = useTheme();
  const {
    vehicleId,
    carpoolingDestination,
    price,
    startStationId,
    startDate,
    endDate,
    searchState,
    ...rest
  } = props;
  const { t } = useTranslation(['search', 'common']);
  const { vehicle } = useVehicleLoader(vehicleId);

  const stateStartDate = searchState.startDate;
  const stateEndDate = searchState.endDate;

  const boxShadow = {
    boxShadow: `0 0 2px 1px ${theme.palette.primary.main}`
  };

  if (vehicle) {
    return (
      <div style={boxShadow} className="carpooling vehicule-card" {...rest}>
        <div className="relative_box image">
          {vehicle.thumbnail_url ? (
            <img src={vehicle.thumbnail_url} alt="" />
          ) : null}
          <h3 className="carpooling-title">{t('search:carpooling-title')}</h3>
        </div>
        <div className="details">
          <div className="desc">
            {carpoolingDestination ? (
              <h3 className="carpooling-text">
                <span className="label">
                  {t('search:carpooling-destination-label')} :
                </span>{' '}
                {carpoolingDestination}
              </h3>
            ) : null}

            {stateStartDate !== startDate || stateEndDate !== endDate ? (
              <>
                <div className="date">
                  <span className="label">
                    {t('search:carpooling-date-requested')} :{' '}
                  </span>
                  {moment(stateStartDate).format(fullSearchFilterDateFormat)} -{' '}
                  {moment(stateEndDate).format(fullSearchFilterDateFormat)}
                </div>

                <div className="carpooling-date">
                  <span className="label">
                    {t('search:carpooling-date-proposed')} :{' '}
                  </span>
                  {moment(startDate).format(fullSearchFilterDateFormat)} -{' '}
                  {moment(endDate).format(fullSearchFilterDateFormat)}
                </div>

                <div className="badge orange lighten-5">
                  <i
                    className="material-icons"
                    style={{ color: '#FF9800', fontSize: '16px' }}
                  >
                    <WarningIcon />
                  </i>
                  <span style={{ color: '#FF9800', marginLeft: '4px' }}>
                    {t('search:adjusted-times')}
                  </span>
                </div>
              </>
            ) : (
              <>
                <div className="date">
                  <span className="label">
                    {t('search:carpooling-date-label')} :{' '}
                  </span>
                  {moment(startDate).format(fullSearchFilterDateFormat)} -{' '}
                  {moment(endDate).format(fullSearchFilterDateFormat)}
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    );
  } else {
    return null;
  }
};

export default VehicleCarPoolingCard;
